export class TiposOcupacionesConfiguracionesDescuentosSalarios{
  idTipoOcupacionConfiguracionDescuentoSalario : string;
  idTipoOcupacionConfiguracion : string;
  desde : number;
  hasta : number;
  porcentajeDescuentoLey :number
  porcentajeImpuesto: number;
  indicadorHabilitado : boolean
  auditoriaFecha : Date;
  auditoriaUsuario: string;
}
